export const participants1 = [
    {name: 'Pabbi', id: 1},
    {name: 'Steinunn Dís', id: 2},
    {name: 'Magnús Kjartan', id: 3},
]

export const transactions1 = [
    {title: 'Matur', amount: 10000, participants: [1, 2, 3], paidBy: 2},
    {title: 'Bensín', amount: 5000, participants: [1, 2], paidBy: 1},
]

export const participants2 = [
    {name: 'Sævar', id: 1},
    {name: 'Andri', id: 2},
    {name: 'Gummi', id: 3},
    {name: 'Baldur', id: 4},
    {name: 'Jói', id: 5},
    {name: 'Haffi', id: 6},
    {name: 'Magnús', id: 7},
    {name: 'Hjalti', id: 8},
    {name: 'Björn', id: 9},
]

export const transactions2 = [
    {title: 'Paintball grunngjald', amount: 81130, participants: [1, 2, 3, 4, 5, 6, 7], paidBy: 2},
    {title: 'Paintball grunngjald Völundur', amount: 11590, participants: [1, 2, 3, 4, 5, 6, 7, 8, 9], paidBy: 2},
    {title: 'Skylmingar rest', amount: 13000, participants: [1, 2, 3, 4, 6], paidBy: 2},
    {title: 'Pílubás', amount: 7950, participants: [1, 2, 3, 6], paidBy: 1},
    {title: 'Paintball kúlur Völundur', amount: 4400, participants: [1, 2, 3, 4, 5, 6, 7, 8, 9], paidBy: 2},
    {title: 'Viskí', amount: 10100, participants: [1, 2, 3, 6], paidBy: 3},
    {title: 'Matur Völundur', amount: 5790, participants: [1, 2, 3, 4, 5, 6, 7, 8, 9], paidBy: 2},
    {title: 'Subway', amount: 14000, participants: [1, 2, 3, 4, 5, 6, 7], paidBy: 1},
    {title: 'Sódavatn', amount: 1400, participants: [1, 2, 3, 4, 5, 6, 7], paidBy: 1},
    {title: 'Bjór', amount: 6015, participants: [1, 2, 3, 4, 5, 6], paidBy: 1},
    {title: 'Skylmingar Völundur', amount: 2250, participants: [1, 2, 3, 4, 5, 6, 7, 8, 9], paidBy: 2},
    {title: 'Skylmingar hálfur tími', amount: 2250, participants: [5, 7], paidBy: 2},
]

export const participants3 = [
    {name: 'Jói', id: 1},
    {name: 'Sigga', id: 2},
    {name: 'Gunni', id: 3},
]

export const transactions3 = [
    {title: 'Matur', amount: 10000, participants: [1, 2, 3], paidBy: 2},
    {title: 'Bensín', amount: 5000, participants: [1, 2], paidBy: 1},
]